import { render, staticRenderFns } from "./SubmitModeration.vue?vue&type=template&id=0dcd6dde"
import script from "./SubmitModeration.vue?vue&type=script&lang=js"
export * from "./SubmitModeration.vue?vue&type=script&lang=js"
import style0 from "./SubmitModeration.vue?vue&type=style&index=0&id=0dcd6dde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports